'use client';

import * as React from 'react';
import { Player, PlayerVerificationStatus } from '@alien-platform/bo-core';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import { CaretDown } from '@phosphor-icons/react/dist/ssr/CaretDown';
import dayjs from 'dayjs';

export function PlayerKYCTab({ playerData }: { playerData: Player | undefined }): React.JSX.Element {
  const verifications = playerData?.kyc?.verifications;

  //   const showConfirmRejectButtons = checkPermissionsClient({
  //     componentId: 'approve_reject_kyc',
  //     user,
  //   });

  return (
    <Stack direction="column">
      {!playerData ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
          <CircularProgress color="primary" size={38} />
        </Box>
      ) : (
        <Stack gap={2}>
          <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<CaretDown />} aria-controls="panel1-content" id="panel1-header">
              <Typography variant="h6">{dayjs(verifications?.[0].createdAt).format('YYYY-MM-DD HH:mm:ss')}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0 }}>
              <Box
                sx={{
                  display: 'grid',
                  gap: 4,
                  gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, 1fr)' },
                }}
              >
                {verifications?.map((item) => (
                  <Box key={item.uuid}>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                      {item.title}
                    </Typography>
                    <Box
                      sx={{
                        overflow: 'hidden',
                        borderRadius: '8px',
                        border: '1px solid var(--mui-palette-divider)',
                        flexGrow: 1,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Table sx={{ borderCollapse: 'separate', borderRadius: '8px' }}>
                        <TableHead>
                          <TableRow>
                            <TableCell>File</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={1} sx={{ width: '100%' }}>
                              <img
                                src={!item.fileUrl || item.fileUrl === '' ? '/assets/not-found.svg' : item.fileUrl}
                                alt="for blanks"
                                style={{
                                  height: '120px',
                                  width: '100%',
                                  objectFit: !item.fileUrl || item.fileUrl === '' ? 'contain' : 'cover',
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>

                    {item.status !== PlayerVerificationStatus.CONFIRMED &&
                    item.status !== PlayerVerificationStatus.REJECTED ? (
                      <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mt: 2 }}>
                        <Button variant="contained" color="error">
                          Reject
                        </Button>
                        <Button variant="contained" color="primary">
                          Approve
                        </Button>
                      </Box>
                    ) : null}
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        </Stack>
      )}
    </Stack>
  );
}
